import { render, staticRenderFns } from "./VaccineTransfer.vue?vue&type=template&id=404929f4&scoped=true"
import script from "./VaccineTransfer.vue?vue&type=script&lang=js"
export * from "./VaccineTransfer.vue?vue&type=script&lang=js"
import style0 from "./VaccineTransfer.vue?vue&type=style&index=0&id=404929f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404929f4",
  null
  
)

export default component.exports